import React from 'react';

import { useIntl } from 'react-intl';

import Headings from 'components/Headings';
import { TileSkeleton } from 'components/StaticStoriesList/TileSkeleton';
import StoryListTile from 'components/StoryListTile';

import { useStoriesForTileQuery } from 'graphql/generated/graphql';

import { useAuth } from 'hooks/useAuth';
import useGraphaelDefaults from 'hooks/useGraphaelDefaults';
import useStaticValues from 'hooks/useStaticValues';

import './style.scss';

const AudioOfTheDay = () => {
  const { user } = useAuth();
  const { locale } = useIntl();
  const { mostListenedByKinkines: stories } = useStaticValues();

  const daysSinceEpoch = calculateDaysSinceEpoch();

  const kinkiness = user?.modeKinkiness || defaultKinkiness;

  const storiesForKindiness = stories[kinkiness];
  const storiesForLocale = storiesForKindiness[locale];

  const storyId = storiesForLocale[daysSinceEpoch % storiesForLocale.length];

  const { data, loading } = useStoriesForTileQuery({
    ...useGraphaelDefaults(),
    variables: { filterSelection: { storyIds: [storyId] } },
  });

  if (!loading && !data?.stories.stories[0]) return null;

  return (
    <div className="AudioOfTheDay">
      <Headings
        title={{ id: 'components.NewExplorePage.AudioOfTheDay.title' }}
        config={{ titleAlignCenter: false }}
      />
      {loading ? (
        <TileSkeleton />
      ) : (
        data && (
          <StoryListTile
            endpoint="explore"
            story={data?.stories.stories[0]}
            positionInList={0}
            matomoProps={{
              name: `explore-audio-of-the-day_${storyId}}`,
            }}
          />
        )
      )}
    </div>
  );
};

export default AudioOfTheDay;

export const defaultKinkiness = 4;

export const calculateDaysSinceEpoch = () => {
  const millisecondsPerDay = 1000 * 60 * 60 * 24;

  return Math.floor(Date.now() / millisecondsPerDay);
};
